import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { OnboardingSlidesComponent } from '../onboarding-slides/onboarding-slides.component';
import { SLIDE_MODAL_CONFIGS } from '@app/utils/constants/modal.constants';
import { AppRoutes } from '@app/utils/enums/routes.enum';

@Component({
  selector: 'app-home-body',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './home-body.component.html',
  styleUrl: './home-body.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeBodyComponent {
  private readonly router = inject(Router);
  private readonly modal = inject(MatDialog);

  public goShopSettings(): void {
    this.router.navigate([AppRoutes.SETTINGS]);
  }

  protected showOnboardingSlides(): void {
    this.modal.open(OnboardingSlidesComponent, SLIDE_MODAL_CONFIGS);
  }
}
